import queryString from 'query-string';
import { isNil, pickBy } from 'lodash';

// Unset params (undefined or null) are left out. query-string would write a null as a bare `&key`,
// which the API reads as "present": a choice filter rejects it (400), a flag like only_deleted switches
// on. An empty string or list is still sent as-is.
export const generateQSParams = (params) => queryString.stringify(pickBy({ ...params }, (item) => !isNil(item)));
